// =====================================
//
//   ComplexPdt Controller
//   Author: Gray
//   createtime: 2016 / 09 / 05
//
// =====================================

window.InifECMobileApp.controller("ComplexPdtController", ['$scope', '$state', '$timeout', '$rootScope', 
    '$stateParams', 'ComplexPdtService', '$WebTitle', '$PreviousState', '$InifECGA', 'UserService',
	function($scope, $state, $timeout, $rootScope, 
        $stateParams, ComplexPdtService, $WebTitle, $PreviousState, $InifECGA, UserService) {

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var pdtClass = undefined;

            if($scope.product) {
                if($scope.product.pdtClassURLParam) {
                    pdtClass = $scope.product.pdtClassURLParam;
                } else {
                    pdtClass = $scope.product.pdtClass;
                }
            }
            var backState = $PreviousState.getProductPrevious(pdtClass);

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 取得商品資訊
        // --------------------------------
        var getComplexPdtMap = function() {

            $scope.isLoading = true;

            ComplexPdtService.getComplexPdtMap($scope.complexid).then(function(result) {

                if(result) {
                    $scope.complex = result;
                    $scope.complex.productList = [];

                    for(var i = 0; i < result.productids.length; i++) {

                        var product = $scope.complex.productMap[result.productids[i]];

                        if(product != undefined) {
                            $scope.complex.productList.push(product);
                        }
                    }
 
                    $timeout(function(){
                        $scope.product = $scope.complex.productMap[$scope.productid];

                        var title = $scope.complex.name + " | inif印衣服，巧昱服飾設計有限公司";
                        $WebTitle.setWebTitle(title);

                        var ga_info = {
                            productid: $scope.productid,
                            name: $scope.product.name,
                            mrscid: (UserService.user && UserService.user.mrscid) ? UserService.user.mrscid : 'visitor',
                            pdtclass: $scope.product.pdtClass,
                            pdtClassName: $scope.product.pdtClassName,
                            from: $scope.fromState,
                        }

                        $InifECGA.eventTrack('product', 'view', ga_info.productid);
                        $InifECGA.eventTrack('product', 'view_with_name', ga_info.name);
                        $InifECGA.eventTrack('product', 'view_with_mrscid', ga_info.mrscid);
                        $InifECGA.eventTrack('product', 'view_with_pdtclass', ga_info.pdtclass);
                        $InifECGA.eventTrack('product', 'view_with_pdtclassname', ga_info.pdtClassName);
                        $InifECGA.eventTrack('product', 'view_from', ga_info.from);
                        $InifECGA.eventTrack('product', 'view_with_fullinfo', JSON.stringify(ga_info));
                    })
                    
                    $scope.isLoading = false;

                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }

            }, function(error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        let setPreview = function (idx) {
            $scope.previewIndex = idx;
        }

        // ------------------------------
        // getSelectImage
        // ------------------------------
        var getSelectImage = function(product) {

            var src = '';

            if(product && Array.isArray(product.covers) && product.covers.length > 0) {

                var index = $scope.previewIndex || 0;

                src = product.covers[index];
            }

            return src;
        }

        // ------------------------------
        // getCoverImage
        // ------------------------------
        var getCoverImage = function(cover) {

            return cover;
        }

        var init = function() {
            getComplexPdtMap();
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {

            $scope.fromState = fromState.name;
        });

        //==========================
        //  Members
        //==========================
        $scope.complexid = $stateParams.complexid;
        $scope.productid = $stateParams.productid;
        $scope.isLoading = false;
        $scope.isError = false;
        $scope.product = undefined;
        $scope.complex = undefined;
        $scope.className = undefined;
        $scope.price = 0;
        $scope.fromState = '';
        $scope.previewImg = 0;

        //==========================
        //  Methods
        //==========================
        $scope.goBack = goBack;
        $scope.addToShoppingCart;
        $scope.getViewPrice;
        $scope.isOrderItemSpecError;
        $scope.setPreview = setPreview;
        $scope.getSelectImage = getSelectImage;
        $scope.getCoverImage = getCoverImage;

        //==========================
        //  Init
        //==========================
        init();
	}
]);